export var actionKey = '@@APP';
//# sourceMappingURL=constants.js.map